import { Box } from "@chakra-ui/react";
import { FC } from "react";

export const Main: FC = ({ children }) => (
  <Box as="main" px={{base: 4, md: 6, lg: 12}} maxWidth="900px" width="100%">
    {children}
  </Box>
);
